import type { ReactNode } from "react";

export const STEPPER_TYPE = Object.freeze({
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
} as const);

type StepperType = (typeof STEPPER_TYPE)[keyof typeof STEPPER_TYPE];

export interface StepperTabsProps {
  children: ReactNode;
  onStepperTabChange?: (index: number) => boolean | void | Promise<boolean | void>;
  testId?: string;
  currentStepIndex?: number;
  stepperType?: StepperType;
  isTypeChangeable?: boolean;
}

export interface StepperTabsHandle {
  setStepperTab: (index: number) => void;
  getActiveStepperTab: () => number;
  next: () => void;
  back: () => void;
  reset: () => void;
  getStepCount: () => number;
}

export interface StepperTabPanelProps {
  label: string;
  children: ReactNode;
  status?: StepStatusValue;
}

export const StepStatus = Object.freeze({
  CURRENT: "CURRENT",
  COMPLETE: "COMPLETE",
  INCOMPLETE: "INCOMPLETE",
  ERRORS: "ERRORS",
});

export type StepStatusValue = (typeof StepStatus)[keyof typeof StepStatus];
